
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    processing: Boolean,
    outcome: Boolean,
  },
});
